<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";
import { vodafoneLabContactMixin } from "../../modules/vodafone_lab_mixins_module.js"
import { interactionMixin } from "src/modules/interactions_module.js";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabBasicMixin, interactionMixin, vodafoneLabContactMixin],
  computed: {
    hideLayer() {
      return Fandom.exists(this.content.hide_layer) ? this.content.hide_layer : false;
    }
  }
};
</script>

<template>
  <div 
    v-if="isContentVisibleToUser()" 
    v-easyadmin="easyadminId" 
    :class="contentType" 
    page-article
    page-article-component
    class="position-relative"
  >
    <breadcrumb :breadcrumb="pageModel.breadcrumb"></breadcrumb>
    <div class="bg-cover-center d-flex align-items-md-center page-header position-relative" :style="{'background-image': getContentResponsiveImageURL('image')}">
      <div class="position-absolute-center layer" v-if="!hideLayer"></div>
      <div class="container-md px-md-4">
        <div class="row py-md-5">
          <div class="col-12 col-md-9 col-lg-6 d-none d-md-block" v-if="content.title">
            <h1 class="h2 text-white display-1 mb-4 mb-md-5">{{content.title}}</h1>
            <a :href="content.button.url" :target="getTarget(content.button)" class="btn" :class="content.button_class || 'btn-primary'" v-if="content.button">{{content.button.title}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-4 mb-md-5">
      <stripe-article-interactions
        v-if="content.share"
        class="justify-content-end"
        :content="content"
        :opt-container-content="containerContent"
      ></stripe-article-interactions>
      <page-article-red-banner :content="content.red_banner" :opt-container-content="containerContent" v-if="content.red_banner"></page-article-red-banner>
    </div>
    <div class="container mt-4" v-if="lastUpdatedAt">
      <div class="row justify-content-center">
        <div class="col-lg-7 small">{{ft('globals.updated_at')}} {{lastUpdatedAt}}</div>
      </div>
    </div>
    <div class="container my-4 my-md-5 d-md-none">
      <div class="row">
        <div class="col-12 col-md-6 display-1" v-if="content.title">{{content.title}}</div>
      </div>
    </div>
    <component
      :key="stripe.$id"
      :content="stripe"
      :is="stripe.layout"
      :opt-container-content="containerContent"
      :width="7"
      v-for="(stripe) in content.stripes"
    ></component>
    <div class="container py-4 py-md-5" v-if="content.decorators['category']">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-7">
          <div class="d-flex flex-wrap">
            <a v-for="category in (content.decorators['category'] || [])" class="btn btn-sm btn-outline-primary rounded-pill px-3 py-1 mx-2" :href="applyContextToUrl(pageModel.decorators.category[category].slug)">
              {{pageModel.decorators.category[category].title}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <vote-interaction class="mb-md-5 pb-3" :content="content"></vote-interaction>
    <related-collections :content="content"></related-collections>
    <stripe-contact-us :content="contactStripe" v-if="contactStripe"></stripe-contact-us>
  </div>
</template>

<style lang="scss">
[page-article-component] {

  .page-header {
    min-height: calc(100vw * .5625);

    @include media-breakpoint-up(md) {
      min-height: 60vh;
    }
  }

  .layer {
    background-color: rgba(0,0,0,.25);
  }

  .author-image {
    max-height: 5rem;
    max-width: 10rem;
    height: auto;
    width: auto;
    display: inline-block;
  }
}
</style>
